
export default (html) => {
  return html.replace(/<[^>]+/g, function (match) {
    return match.replace(/ on\w+="[^"]*"/g, '')
  }).replace(/<script[^>]*>/g, '')
}
